import React, { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import moment from 'moment';
import { selectUser } from '../../slice/userSlice';
import { pushToast } from '../../slice/appSlice';
import { CloseIcon } from '../../assets/images';
import { CXButton, CXTextInput } from '../../components/CXForm';
import { CRow, CCol, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell } from '@coreui/react-pro';
import { Modal } from 'react-bootstrap';
import { getContrailWhitelist, createContrailWhitelist } from '../../services/contrailAPI';
import _ from 'lodash';

const ContrailConfigPage = () => {
  const dispatch = useAppDispatch();
  const { userId } = useAppSelector(selectUser);
  const [displayCreateModal, setDisplayCreateModal] = useState(false);
  const [ufiString, setUfiString] = useState<string>('');
  const [ufiList, setUfiList] = useState<string[]>([]);
  const [whiteList, setWhiteList] = useState<{
    ufi: string,
    requestBy: string,
    status: string,
    createdAt: string,
    updatedAt: string
  }[]>([]);

  const searchAll = () => {
    getContrailWhitelist().then(res => {
      if (res?.status === 500) {
        console.log('getContrailWhitelist failed, res=', res);
      } else if (!_.isEmpty(res)) {
        console.log('getContrailWhitelist res=', res);
        const filteredWhiteList = res.filter(item => item.status === 'enable');
        setWhiteList(filteredWhiteList);
      }
    }).catch(err => {
      console.log(err);
    });
  }

  const handleAddFlight = () => {
    if (_.isEmpty(ufiList)) {
      dispatch(pushToast({ type: "error", message: "Please input UFI" }));
      return;
    }
    createContrailWhitelist({
      ufi: _.join(ufiList, ','),
      requestBy: userId,
      status: 'enable'
    }).then(res => {
      if (res?.status === 500) {
        console.log('createContrailWhitelist failed, res=', res);
      } else {
        searchAll();
        closeModal();
      }
    }).catch(err => {
      console.log(err);
    });
  };

  const closeModal = () => {
    setUfiString("");
    setUfiList([]);
    setDisplayCreateModal(false);
  }

  const openModal = () => {
    setDisplayCreateModal(true);
  }

  const addUfiString = () => {
    let processedUfiString = ufiString.replaceAll(/ +/g, "").toUpperCase();
    setUfiList(_.concat(ufiList, processedUfiString.split(',')));
    setUfiString("");
  };

  const removeUfi = (index: number) => {
    setUfiList(ufiList.filter((_, i) => i !== index));
  };

  useEffect(() => {
    searchAll();
  }, []);

  return (
    <>
      <div className={"CathaySansBd"} style={{ fontSize: "2rem", lineHeight: "2.25px" }}>Contrail Configuration</div>
      <div className={"section d-flex justify-content-between"} >
        <div className={"p-2 ms-auto"}>
          <CXButton outline={false} text={"Add Flight"} onClick={() => openModal()} />
        </div>
      </div>
      <CTable className="whiteListTable" borderless hover>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell>UFI</CTableHeaderCell>
            <CTableHeaderCell>Request By</CTableHeaderCell>
            <CTableHeaderCell>Request Time</CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {whiteList.map((item, index) => (
            <CTableRow key={index}>
              <CTableDataCell>{item.ufi}</CTableDataCell>
              <CTableDataCell>{item.requestBy}</CTableDataCell>
              <CTableDataCell>{moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}</CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>
      <Modal show={displayCreateModal} onHide={closeModal} className='contrail-modal'>
        <Modal.Header className="modal-header" closeButton>
          <Modal.Title>
            {"Add new Contrail flight"}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "auto" }}>
          <CRow>
            <CCol xs={6}>
              <div className={"CathaySansMd"} style={{ fontSize: "18px", lineHeight: "22px" }}>Add UFI to Contrail whitelist</div>
            </CCol>
            <CCol xs={6}>
              <CRow>
                <CCol xs={12}>
                  <div className={"tips"}>Please input UFI here and separate each by a comma ‘,’</div>
                </CCol>
              </CRow>
              <CRow>
                <CCol xs={9}>
                  <CXTextInput
                    value={ufiString}
                    onChange={setUfiString}
                    hasLabel={false}
                    placeholder='For example CPA324523MAR2025WIIIVVNB'
                  />
                </CCol>
                <CCol xs={3}>
                  <CXButton text={"Add"} width={"100%"} disabled={!ufiString} onClick={() => addUfiString()} />
                </CCol>
              </CRow>
              <CRow>
                <CCol xs={12}>
                  {ufiList.map((ufi, index) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span>{ufi}</span>
                      <button onClick={() => removeUfi(index)} style={{ marginLeft: '10px', cursor: 'pointer', background: 'none', border: 'none' }}>
                        <CloseIcon width={25} height={25} />
                      </button>
                    </div>
                  ))}
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <div className='cancel-button'><CXButton outline={true} text={"Cancel"} onClick={() => closeModal()}
            fontSize={"16px"} width={"100%"} /></div>
          <div className='save-button'><CXButton text={"Create"}
            onClick={() => handleAddFlight()} fontSize={"16px"}
            width={"100%"} /></div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContrailConfigPage;